export default "https://cdn-static-staging.gokick.com/assets/de9826e8866da471b448810e2f95d57cb57ac3c9/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";